import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import Dock from 'react-dock';

import { MODAL } from '../constants/constants';

export const ModalDock = ({ ...options }) => {
	const {
		showState,
		closeMethod,
		title,
		body,
		display,
		isFluid = true,
		position = 'right',
		size = 0.8,
		duration = 500
	} = options;
	if (display === MODAL) {
		return (
			<Modal show={showState} onHide={() => closeMethod()}>
				<div className="m-1">
					<Modal.Header closeButton>
						<Modal.Title className="text-center">
							<span className="h3 font-weight-bold">{title}</span>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>{body}</Modal.Body>
				</div>
			</Modal>
		);
	} else if (showState) {
		const closeButton = (
			<button
				type="button"
				aria-label="Close"
				className="close text-muted font-weight-bold "
				onClick={() => closeMethod()}
			>
				<i className="ddc-icon ddc-icon-close" aria-hidden="true" />
			</button>
		);

		const dockHeader = (
			<div className="my-4">
				{closeButton}
				<div className="text-center">
					<h4>{title}</h4>
				</div>
			</div>
		);

		const dockerBody = <div className="border-top pt-4">{body}</div>;

		return (
			<Dock
				isVisible={showState}
				position={position}
				size={size}
				fluid={isFluid}
				duration={duration}
				onVisibleChange={() => closeMethod()}
			>
				<div className="m-3">
					<div>{dockHeader}</div>
					<div>{dockerBody}</div>
				</div>
			</Dock>
		);
	} else {
		return null;
	}
};

ModalDock.propTypes = {
	showState: PropTypes.bool.isRequired,
	closeMethod: PropTypes.func.isRequired,
	title: PropTypes.element.isRequired,
	body: PropTypes.element.isRequired,
	display: PropTypes.string.isRequired
};

export default ModalDock;



// WEBPACK FOOTER //
// ./src/components/ModalDock.jsx